export const EnvironmentConfig = {
  buyerClientId: '9DF10757-2BEE-47BB-9EDA-C35F3DAB54FB',
  sellerClientId: 'D3E03000-09D1-4A9F-B5C2-592BF82157D8',
  baseApiUrl: 'https://westeurope-sandbox.ordercloud.io',
  apiMiddlewareUrl: 'https://dayco-aftermarket-mw-qa.azurewebsites.net/',
  firebaseUrl: 'https://firebasestorage.googleapis.com/v0/b/react-http-51a82.appspot.com/o/',
  gaTrackingId: '',
};
